import { DataTableCol } from "../../../components/tables/types";

export const projectDataGridCols: DataTableCol[] = [
    {
        title: 'Created Date',
        control: 'createdAt',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Domain',
        control: 'courseName',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Project Name',
        control: 'projectName',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Actions',
        control: 'both',
        sortable: false,
        isEdit: true,
        isDelete: true,
        canShowColumn: true,
    },
];